export default {
  // Navigation
  'nav.home': 'HOME',
  'nav.cases': 'THE CASES',
  'nav.romania': 'Romania Proceedings',
  'nav.uk': 'United Kingdom Proceedings',
  'nav.us': 'United States Extradition',
  'nav.janeDoe': 'Palm Beach: Jane Doe Defamation',
  'nav.onlineDefamation': 'Tate v. X: Amended Complaint Dismissed',
  'nav.matrixAgents': 'Matrix Agents',
  'nav.pencov': 'Related: Pencov v. Doe',
  'nav.legalTimeline': 'Legal Timeline',
  'nav.about': 'ABOUT',
  'nav.aboutTates': 'About the Tates',
  'nav.aboutTateProtest': 'About Tate Protest',
  'nav.wilPujols': 'Wil Pujols',
  'nav.supporters': 'SUPPORTERS',
  'nav.fans': 'Fans',
  'nav.faq': 'FAQ',
  'nav.evidence': 'EVIDENCE',
  'nav.matrix': 'THE MATRIX',
  'nav.matrixPage': 'The Matrix',
  'nav.archive': 'THE ARCHIVE',
  'nav.caseCredits': 'CASE CREDITS',
  'nav.getInvolved': 'GET INVOLVED',
  'nav.miamiProtest': 'Miami Protest',
  'nav.londonProtest': 'London Protest',
  'londonProtest.kicker': 'Planned · Details pending',
  'londonProtest.title': 'London Protest',
  'londonProtest.description': 'A peaceful protest is being planned in London. The date and exact location have not yet been confirmed.',
  'londonProtest.illustrationNote': 'Illustrative image · Not a photo of this event',
  'londonProtest.cardDescription': 'London · Dates and venue awaiting confirmation.',
  'londonProtest.viewDetails': 'View London protest',
  'londonProtest.dateLabel': 'Date',
  'londonProtest.dateValue': 'Awaiting confirmation',
  'londonProtest.cityLabel': 'City',
  'londonProtest.cityValue': 'London, UK',
  'londonProtest.venueLabel': 'Venue',
  'londonProtest.venueValue': 'Awaiting confirmation',
  'londonProtest.notConfirmed': 'No date, time, meeting point, or venue has been confirmed. Please do not make travel arrangements based on this page yet.',
  'londonProtest.nextLabel': 'Stay informed',
  'londonProtest.updatesTitle': 'Get updates when details are confirmed',
  'londonProtest.updatesBody': 'Visit our updates form to hear about future announcements. Sign-up is for general Tate Protest updates; no London-specific notification is promised.',
  'londonProtest.updatesButton': 'Receive updates',
  'londonProtest.peacefulNote': 'Any gathering should remain peaceful and comply with local laws and instructions from authorities. Check this page for confirmed details before attending.',
  'londonProtest.standardsLink': 'Read our peaceful protest standards',
  'miamiProtest.kicker': 'Organizer-confirmed plans · Miami',
  'miamiProtest.title': 'Miami Protest',
  'miamiProtest.description': 'Peaceful supporter protests are planned outside the Clyde C. Atkins United States Courthouse on November 19 and 20, 2026. These are organizer-confirmed protest plans, separate from the court’s scheduled proceedings.',
  'miamiProtest.cardDescription': 'November 19 & 20, 2026 · Both mornings at 8:00 AM EST.',
  'miamiProtest.viewDetails': 'View Miami protest details',
  'miamiProtest.plansKicker': 'Two separate gatherings',
  'miamiProtest.plansTitle': 'November 19 & 20',
  'miamiProtest.localTime': 'Miami local time · EST (UTC−5)',
  'miamiProtest.dayLabel': 'Protest plan · Day {{number}}',
  'miamiProtest.forHearing': 'Planned in support of due process for {{name}}',
  'miamiProtest.venueLabel': 'Planned gathering location',
  'miamiProtest.courtKicker': 'Separate court schedule',
  'miamiProtest.courtTitle': 'Final extradition hearings',
  'miamiProtest.courtIntro': 'The court has separately scheduled final extradition hearings, listed below. The protests are independent supporter plans, not court events.',
  'miamiProtest.courtLink': 'View court-confirmed hearing details',
  'miamiProtest.courtFor': 'Court-confirmed hearing · {{name}}',
  'miamiProtest.courtNotice': 'Hearing dates are subject to change by court order. The 8:00 AM gatherings are supporter protest plans, not court events.',
  'miamiProtest.photosKicker': 'Supporter community',
  'miamiProtest.photosTitle': 'Supporter gathering photographs',
  'miamiProtest.photosCaption': 'These supplied photographs show a separate supporter gathering. They are not photographs of the upcoming November protest plans.',
  'miamiProtest.photoOneAlt': 'Supporters gathered beside a large scorpion sculpture; two people in the foreground hold phones.',
  'miamiProtest.photoTwoAlt': 'A wider view of a supporter crowd with palm trees and a large scorpion sculpture.',
  'miamiProtest.motionPause': 'Pause background motion',
  'miamiProtest.motionResume': 'Play background motion',
  'miamiProtest.guidanceKicker': 'Before you attend',
  'miamiProtest.guidanceTitle': 'Peaceful, lawful, considerate',
  'miamiProtest.guidanceBody': 'These are the public event details currently confirmed. No permit or court authorization is represented here; follow applicable laws and official instructions.',
  'miamiProtest.guidance.peace': 'Keep the gathering peaceful. No weapons, threats, violence, or provocation.',
  'miamiProtest.guidance.law': 'Follow local laws, courthouse rules, and all lawful instructions from authorities.',
  'miamiProtest.guidance.access': 'Keep entrances, sidewalks, and public access clear. Do not obstruct courthouse operations.',
  'miamiProtest.guidance.updates': 'Check this page before traveling for any changes to event or court scheduling.',
  'miamiProtest.independenceNote': 'The protest plans are independent supporter activity, not court events. No court authorization or permit status is claimed.',
  'miamiProtest.standardsLink': 'Read our peaceful protest standards',
  'nav.donate': 'Donate',
  'nav.support': 'Support Tate Protest',

  // Sitewide protest announcement
  'protestAnnouncement.label': 'Current court date status',
  'protestAnnouncement.kicker': 'Case status',
  'protestAnnouncement.date': 'August 27',
  'protestAnnouncement.venue': 'C. Clyde Atkins U.S. Courthouse',
  'protestAnnouncement.address': '301 North Miami Avenue, Miami, Florida 33128',
  'protestAnnouncement.arrival': 'Peaceful protest 9:00 AM · hearing 10:00 AM',
  'protestAnnouncement.detailsButton': 'Join Protests',
  'protestAnnouncement.donateButton': 'Support Tate Protest',
  'miami.events.supporters.name': 'Tate Supporters Get-Together',
  'miami.events.protest.name': 'Peaceful Protest',
  'miami.events.hearing.name': 'Court / Detention Hearing',
  'miami.meta.eventDescription': 'Peaceful protest held on {{protestDate}} at {{protestTime}} at {{venue}}, {{address}}. Next court date: {{nextCourtDate}}.',
  'donate.meta.supportPrefix': 'Support Tate Protest’s independent advocacy.',
  'donate.meta.supportSuffix': 'Help fund outreach materials, supplies, communications, and logistics.',

  // Countdown timer (shared)
  'countdown.days': 'DAYS',
  'countdown.hours': 'HRS',
  'countdown.minutes': 'MIN',
  'countdown.seconds': 'SEC',
  'countdown.today': 'COURT DATE IS TODAY',

  // Hero
  'home.hero.subtitle': 'Truth. Evidence. Freedom.',
  'home.hero.description': 'Independent advocacy, public documentation, and peaceful action in support of due process for Andrew and Tristan Tate.',
  'home.hero.viewCase': 'View the Latest Case Update',
  'home.hero.join': 'Join the Movement',
  'home.hero.nextCourtDate': 'REQUEST STATUS',
  'home.hero.courtDate': 'Received September 9, 2026',
  'home.hero.noNextCourtDate': 'The September 16 treaty submission deadline was satisfied.',
  'home.hero.before': 'Before',
  'home.hero.judge': 'U.S. Magistrate Judge Lauren Fleischer Louis',
  'home.hero.location': 'Southern District of Florida · Detention hearing concerning release pending extradition proceedings.',
  'home.hero.scheduled': 'Scheduled — Subject to Change',
  'home.hero.viewSource': 'View Source',
  'home.hero.updateKicker': 'Confirmed Hearing Update',
  'home.hero.updateHeadline': 'FINAL EXTRADITION HEARINGS SET',
  'home.hero.updateSubheadline': 'October 9 court orders set Andrew Tate’s hearing for November 19 and Tristan Tate’s for November 20, 2026, at 10:00 AM EST in Miami.',
  'home.hero.viewTimeline': 'VIEW THE TIMELINE',
  'home.hero.followUpdate': 'Join Protests',
  'home.hearingUpdate.eyebrow': 'Confirmed hearing dates',
  'home.hearingUpdate.asOf': 'Court orders entered October 9, 2026',
  'home.hearingUpdate.title': 'Final extradition hearings set for November',
  'home.hearingUpdate.summary': 'October 9 paperless orders adopted the proposed schedules: Andrew Tate on November 19 and Tristan Tate on November 20, both at 10:00 AM EST in Miami.',
  'home.hearingUpdate.note': 'These hearings concern the UK’s extradition requests, not criminal guilt trials. Both brothers deny wrongdoing. Dates subject to change by court order.',
  'home.hearingUpdate.cta': 'View hearing details',
  'home.hearingUpdate.heroCaption': 'Final hearings · November 19 & 20, 2026',
  'home.hearingUpdate.heroSummary': 'Separate final extradition hearings have been scheduled for Andrew and Tristan Tate in Miami.',

  // Upcoming Gatherings
  'home.events.kicker': 'Mark Your Calendar',
  'home.events.title': 'Two Days. Two Gatherings.',
  'home.events.description': 'Join us in Miami for a supporters get-together, then a peaceful demonstration, followed by a community gathering in support of due process.',
  'home.events.timeLabel': 'Start Time',
  'home.events.locationLabel': 'Location',
  'home.events.location': 'C. Clyde Atkins U.S. Courthouse · 301 North Miami Avenue, Miami, Florida 33128',
  'home.events.learnMore': 'View Event Details',
  'home.events.pastStatus': 'PAST EVENT',
  'home.events.gathering.label': 'COMMUNITY GET-TOGETHER',
  'home.events.gathering.title': 'Get-Together',
  'home.events.gathering.month': 'AUG',
  'home.events.supporters.label': 'SUPPORTERS GET-TOGETHER',
  'home.events.supporters.title': 'Tate Supporters Get-Together',
  'home.events.supporters.month': 'AUG',
  'home.events.supporters.desc': 'A welcoming evening for Tate supporters to connect, meet fellow advocates, and build community ahead of the upcoming peaceful events. All are welcome.',
  'home.events.gathering.desc': 'An evening gathering to meet fellow supporters, share stories, and connect before the peaceful demonstration the next morning. All are welcome.',
  'home.events.protest.label': 'PEACEFUL PROTEST',
  'home.events.protest.title': 'Protest',
  'home.events.protest.month': 'AUG',
  'home.events.protest.desc': 'A lawful, peaceful demonstration in support of due process and the presumption of innocence for Andrew and Tristan Tate.',
  'home.events.disclaimer': 'All gatherings are peaceful and lawful. No weapons. No violence. No provocation. Follow organizer and law enforcement instructions at all times.',

  // Latest Movement Update
  'home.update.kicker': 'Latest Movement Update',
  'home.update.countdownLabel': 'COUNTDOWN TO HEARING',
  'home.update.dateChip': 'CURRENT COURT STATUS',
  'home.update.title': 'Formal Extradition Requests Received',
  'home.update.protestLabel': 'PEACEFUL PROTEST',
  'home.update.protestTime': '9:00 AM EDT',
  'home.update.protestLocation': 'C. Clyde Atkins U.S. Courthouse · 301 North Miami Avenue, Miami, Florida 33128',
  'home.update.hearingLabel': 'DETENTION HEARING',
  'home.update.hearingTime': '10:00 AM EDT',
  'home.update.hearingJudge': 'Before U.S. Magistrate Judge Lauren Fleischer Louis',
  'home.update.district': 'Southern District of Florida',
  'home.update.description': 'The August 27 hearing date has passed. No new court date has been announced; this page will be updated when official scheduling information becomes available.',
  'home.update.attendeesNote': 'All attendees must remain peaceful and respectful. This is a lawful assembly in support of due process and the presumption of innocence. No weapons, no violence, no provocation.',
  'home.update.disclaimer': 'Peaceful and lawful assembly only. No weapons. No violence. No provocation. Respect courthouse rules and law enforcement instructions.',
  'home.update.organizedBy': 'Organized by Wil Pujols and Tate Protest',
  'home.update.joinProtest': 'JOIN THE PROTEST',
  'home.update.courtDetails': 'COURT DETAILS',
  'home.update.support': 'SUPPORT THE MOVEMENT',

  // About Tate Protest
  'home.movement.kicker': 'The Movement',
  'home.movement.title': 'Built to Document. Organized to Act.',
  'home.movement.description': 'Tate Protest was founded in March 2023 to bring international attention to the legal proceedings involving Andrew and Tristan Tate and to advocate for due process, transparency, fair treatment, and the presumption of innocence.',
  'home.movement.foundedBy': 'Founded by Wil Pujols',
  'home.movement.founderDesc': 'Wil Pujols is a Florida entrepreneur and cousin of MLB legend Albert Pujols. Through Tate Protest, he organized the 2023 global embassy protest movement, bringing supporters together across multiple countries in coordinated peaceful demonstrations.',
  'home.movement.readStory': 'Read the Tate Protest Story',
  'home.movement.meetFounder': 'Meet the Founder',

  // About the Brothers
  'home.brothers.kicker': 'About',
  'home.brothers.title': 'Who Are Andrew & Tristan Tate?',
  'home.brothers.description': 'Learn about their backgrounds, public careers, and the legal proceedings that have made their cases an international subject of debate.',
  'home.brothers.andrewTitle': 'Andrew Tate',
  'home.brothers.andrewBody': "Andrew Tate is a British-American entrepreneur, former four-time kickboxing world champion, and online commentator. After retiring from professional sports, he built multiple businesses and became one of the world's most recognizable internet personalities.",
  'home.brothers.tristanTitle': 'Tristan Tate',
  'home.brothers.tristanBody': 'Tristan Tate is a British-American entrepreneur and former professional kickboxer. He has partnered with Andrew Tate across multiple business ventures and frequently appears in interviews discussing business, culture, and current events.',
  'home.brothers.learnMore': 'Learn More',

  // Legal Proceedings
  'home.legal.kicker': 'Legal Proceedings',
  'home.legal.title': 'International Case Overview',
  'home.legal.notice': 'Charges and allegations are not findings of guilt. Andrew and Tristan Tate are presumed innocent unless and until proven guilty in a court of law.',
  'home.legal.status': 'Status',
  'home.legal.lastUpdated': 'Last updated:',
  'home.legal.viewCase': 'View Case',
  'home.legal.romaniaCountry': 'Romania',
  'home.legal.romaniaTitle': 'Human Trafficking & Organized Crime Case',
  'home.legal.romaniaStatus': 'New indictment announced September 4, 2026 — preliminary-chamber review pending',
  'home.legal.romaniaSummary': 'The original 2023 Romanian indictment was returned to DIICOT prosecutors in December 2024 and was not permitted to proceed to trial in its submitted form. On September 4, 2026, DIICOT announced a separate new indictment against Andrew Tate on allegations involving trafficking of minors, money laundering, sexual intercourse with a minor, and witness tampering, and against Tristan Tate for alleged complicity. Both deny wrongdoing. The new filing awaits preliminary-chamber review; it is not a trial or a conviction.',
  'home.legal.ukCountry': 'United Kingdom',
  'home.legal.ukTitle': 'Sexual Offenses & Extradition Case',
  'home.legal.ukStatus': 'Criminal charges authorized — extradition proceedings active',
  'home.legal.ukSummary': 'The Crown Prosecution Service authorized criminal charges against Andrew Tate including multiple counts of rape, sexual assault, and controlling or coercive behavior. The UK has formally requested extradition from the United States. An earlier 2015–2019 Hertfordshire investigation into overlapping allegations was closed without charges after detectives uncovered text message evidence of collusion among complainants.',
  'home.legal.usCountry': 'United States',
  'home.legal.usTitle': 'Extradition Proceedings',
  'home.legal.usStatus': 'Detained — bond request denied September 9; extradition proceedings ongoing',
  'home.legal.usSummary': 'Andrew and Tristan Tate remain in U.S. custody. The State Department received the United Kingdom’s formal extradition requests on September 9; the requests are under review and no extradition order has been entered.',
  'home.legal.lastUpdatedRomania': 'September 4, 2026',
  'home.legal.lastUpdatedUk': '2026',
  'home.legal.lastUpdatedUs': 'September 9, 2026',

  // Questions Raised
  'home.questions.kicker': 'Transparency',
  'home.questions.title': 'Questions Raised by Supporters',
  'home.questions.description': 'Supporters have raised questions concerning due process, the length of the proceedings, access to evidence, media coverage, disclosure obligations, treatment in custody, and possible political motivations. Critics dispute those claims and maintain that the allegations should be resolved through the courts. TateProtest.com organizes publicly available information, official documentation, and attributed reporting so readers can examine the record and reach their own conclusions.',
  'home.questions.examine': 'Examine the Public Record',

  // Cases by the Numbers
  'home.numbers.kicker': 'By the Numbers',
  'home.numbers.title': 'The Cases by the Numbers',
  'home.numbers.stat1Label': 'Years Under Investigation',
  'home.numbers.stat1Tooltip': '2015 Hertfordshire investigation through present',
  'home.numbers.stat2Label': 'Countries Involved',
  'home.numbers.stat2Tooltip': 'Romania, United Kingdom, United States',
  'home.numbers.stat3Label': 'Court Hearings',
  'home.numbers.stat3Tooltip': 'Across all jurisdictions since 2015',
  'home.numbers.stat4Label': 'Legal Proceedings',
  'home.numbers.stat4Tooltip': 'Distinct formal matters',
  'home.numbers.proceedingsNote': 'Count reflects distinct formal matters, not individual charges, filings, hearings, appeals or court orders. Updated August 2026.',
  'home.numbers.stat5Label': 'Missed Court Appearances',
  'home.numbers.stat5Tooltip': 'The brothers have attended all scheduled hearings',
  'home.numbers.stat6Label': 'Convictions',
  'home.numbers.stat6Tooltip': 'No final convictions in any jurisdiction as of this update',

  // Timeline
  'home.timeline.kicker': 'Timeline',
  'home.timeline.title': 'Key Legal Events',
  'home.timeline.viewAll': 'View Complete Legal Timeline',
  'home.timeline.m1.date': '2015',
  'home.timeline.m1.title': 'UK Investigation Opens',
  'home.timeline.m1.summary': 'Hertfordshire Constabulary opens a formal investigation into allegations of physical and sexual abuse involving Andrew Tate.',
  'home.timeline.m2.date': '2015–2019',
  'home.timeline.m2.title': 'UK Investigation Closed Without Charges',
  'home.timeline.m2.summary': 'After a 4-year investigation, the CPS concludes there is insufficient credible evidence to meet the charging threshold and closes the case without filing criminal charges.',
  'home.timeline.m3.date': 'December 2022',
  'home.timeline.m3.title': 'Romania Arrest',
  'home.timeline.m3.summary': 'Andrew and Tristan Tate are arrested in a pre-dawn operation at their Bucharest residence on suspicion of human trafficking and organized crime.',
  'home.timeline.m4.date': 'March 2023',
  'home.timeline.m4.title': 'House Arrest',
  'home.timeline.m4.summary': 'The Bucharest Court of Appeal transfers the brothers from pretrial detention to house arrest as Romanian proceedings continue.',
  'home.timeline.m5.date': 'August 21, 2024',
  'home.timeline.m5.title': 'Second Romanian Investigation Expands',
  'home.timeline.m5.summary': 'Romanian authorities announce a second investigation involving allegations including trafficking of minors, money laundering, and attempting to influence witnesses. The Tates deny wrongdoing.',
  'home.timeline.m6.date': 'December 19, 2024',
  'home.timeline.m6.title': 'Original Indictment Returned to Prosecutors',
  'home.timeline.m6.summary': 'The Bucharest Court of Appeal declines to send the original 2023 case to trial and returns it to DIICOT, citing excluded evidence, indictment defects, and legal-rights issues.',
  'home.timeline.m7.date': 'May 2025',
  'home.timeline.m7.title': 'UK Criminal Charges',
  'home.timeline.m7.summary': 'The Crown Prosecution Service authorizes 21 criminal charges including rape, sexual assault, and controlling or coercive behavior.',
  'home.timeline.m8.date': 'April 6, 2026',
  'home.timeline.m8.title': 'Judicial-Control Measures Lifted',
  'home.timeline.m8.summary': 'A Romanian court lifts the remaining preventive judicial-control measures imposed on Andrew and Tristan Tate while Romanian investigations continue.',
  'home.timeline.m9.date': 'May 28, 2026',
  'home.timeline.m9.title': 'Investigation Extended to Speech Allegation',
  'home.timeline.m9.summary': 'DIICOT announces that its investigation of Andrew Tate was extended to include an allegation of continued incitement to hatred or discrimination against women. Tate disputes the characterization.',
  'home.timeline.m10.date': 'July 18, 2026',
  'home.timeline.m10.title': 'Florida Arrest',
  'home.timeline.m10.summary': 'US Marshals arrest the brothers in Miami on a UK provisional extradition request. A detention hearing is set for August 27, 2026.',
  'home.timeline.m11.date': 'September 4, 2026',
  'home.timeline.m11.title': 'New Romanian Indictment Filed',
  'home.timeline.m11.summary': 'DIICOT announces a new indictment against Andrew Tate on allegations involving trafficking of minors, money laundering, sexual intercourse with a minor, and witness tampering, and against Tristan Tate for alleged complicity. Both deny wrongdoing; preliminary-chamber review is required before any trial.',
  'home.timeline.m12.date': 'August 27, 2026',
  'home.timeline.m12.title': 'Federal Bond Hearing',
  'home.timeline.m12.summary': 'Andrew and Tristan Tate appeared in federal court and testified during the hearing on their request for release pending extradition.',
  'home.timeline.m13.date': 'September 9, 2026',
  'home.timeline.m13.title': 'UK Formal Requests Received',
  'home.timeline.m13.summary': 'The U.S. Department of State confirmed receipt of formal UK extradition requests for both brothers within the treaty deadline. The federal court has not ordered extradition.',
  'home.timeline.m14.date': 'September 16, 2026',
  'home.timeline.m14.title': 'Treaty Deadline Satisfied',
  'home.timeline.m14.summary': 'The September 16 submission deadline was satisfied seven days early by the requests received on September 9.',
  'home.timeline.new': 'NEW',
  'home.timeline.next': 'NEXT MAJOR DATE',

  // September 2026 extradition update
  'deadline.kicker': 'Breaking Extradition Update',
  'deadline.date': 'SEPTEMBER 9',
  'deadline.title': 'UK FORMAL EXTRADITION REQUESTS SUBMITTED',
  'deadline.status': 'STATUS: FORMAL REQUESTS RECEIVED SEPTEMBER 9',
  'deadline.body': 'The September 16 submission deadline has been satisfied. The State Department is reviewing the requests before the extradition proceedings move forward. Submission does not mean extradition has been approved.',
  'deadline.countdownLabel': 'Formal requests received within the treaty deadline',
  'deadline.arrived': 'THE SUBMISSION DEADLINE WAS SATISFIED',
  'deadline.timezone': 'The requests were received seven days before the September 16 deadline.',
  'deadline.viewCountdown': 'READ THE COURT DOCUMENT FOR EXTRADITION',
  'deadline.readDocument': 'READ THE COURT DOCUMENT FOR EXTRADITION',
  'deadline.source': 'Case No. 1:26-mj-03259-LFL · Document 67 · Entered September 9, 2026',
  'bondUpdate.breaking': 'Breaking Update',
  'bondUpdate.date': 'September 9, 2026',
  'bondUpdate.title': 'BREAKING: UK FORMAL EXTRADITION REQUESTS SUBMITTED',
  'bondUpdate.body': 'On September 9, 2026, the U.S. Department of State formally received the United Kingdom’s extradition requests for Andrew and Tristan Tate—seven days ahead of the September 16 deadline.',
  'bondUpdate.custody': 'The requests are under State Department review. Submission does not mean extradition has been approved, and the brothers have not been ordered extradited.',
  'bondUpdate.context': 'Andrew and Tristan Tate deny all allegations and retain the right to challenge extradition in federal court.',
  'bondUpdate.whatHappened': 'What was confirmed?',
  'bondUpdate.explanation': 'State Department letters filed on pages 4 and 6 of Document 67 confirm receipt of separate formal extradition requests for Andrew and Tristan Tate within the treaty deadline.',
  'bondUpdate.disclaimer': 'All criminal allegations referenced on this website are allegations. Andrew and Tristan Tate have denied wrongdoing. The extradition process is ongoing.',
  'bondUpdate.readMore': 'READ THE COURT DOCUMENT FOR EXTRADITION',
  'protestAnnouncement.hearingStatus': 'Final Extradition Hearings 11-19, 11-20',
  'caseStatus.title': 'CASE STATUS',
  'caseStatus.andrew': 'Andrew Tate',
  'caseStatus.tristan': 'Tristan Tate',
  'caseStatus.detained': 'DETAINED IN U.S.',
  'caseStatus.bond': 'Bond Request',
  'caseStatus.denied': 'DENIED — SEPTEMBER 9',
  'caseStatus.deadline': 'Formal Requests',
  'caseStatus.september16': 'RECEIVED SEPTEMBER 9',
  'caseStatus.proceedings': 'Extradition Proceedings',
  'caseStatus.ongoing': 'ONGOING',
  'caseStatus.viewCase': 'VIEW U.S. EXTRADITION CASE',
  'newsFeed.kicker': 'Latest Case Update',
  'newsFeed.title': 'UK FORMAL EXTRADITION REQUESTS RECEIVED SEPTEMBER 9',
  'newsFeed.excerpt': 'The State Department confirmed receipt of formal requests for Andrew and Tristan Tate seven days before the treaty deadline. The requests are under review; neither brother has been ordered extradited.',
  'updatePage.home': 'Home',
  'updatePage.breadcrumb': 'Formal Requests Received',
  'updatePage.title': 'UK Formal Extradition Requests Submitted for Andrew and Tristan Tate',
  'updatePage.lede': 'The State Department confirmed receipt of the United Kingdom’s formal requests on September 9, seven days before the treaty deadline.',
  'updatePage.ruling.title': 'The confirmed submission',
  'updatePage.ruling.body': 'State Department letters on pages 4 and 6 of Document 67 confirm formal requests for Andrew and Tristan Tate were received on September 9, 2026.',
  'updatePage.meaning.title': 'What submission means',
  'updatePage.meaning.body': 'The September 16 submission deadline has been satisfied. Submission begins the next review stage; it does not mean extradition has been approved or ordered.',
  'updatePage.context.title': 'Rights and legal status',
  'updatePage.context.body': 'Andrew and Tristan Tate deny all allegations and retain the right to challenge the requests through their attorneys in federal court.',
  'updatePage.next.title': 'What comes next',
  'updatePage.next.body': 'The State Department reviews the requests and supporting materials. The Department of Justice may present them to the federal court, which considers treaty requirements. The brothers may challenge the requests through counsel.',
  'updatePage.documentsTitle': 'Supporting Court Documents',
  'updatePage.documentCaption': 'State Department confirmation filed September 9, 2026, in Case No. 1:26-mj-03259-LFL, Document 67.',
  'updatePage.documentPage': 'Document 67 · Page {{page}}',
  'updatePage.documentAlt': 'State Department confirmation for {{subject}}, Document 67, page {{page}}',
  'updatePage.whatNext1': 'The State Department reviews the UK’s formal requests and supporting materials.',
  'updatePage.whatNext2': 'The Department of Justice may present the requests to the federal court.',
  'updatePage.whatNext3': 'The court considers whether the treaty’s legal requirements are satisfied.',
  'updatePage.whatNext4': 'The Tate brothers may challenge the requests through their attorneys.',
  'updatePage.whatNext5': 'Submission alone does not establish guilt or guarantee extradition.',
  'updatePage.sourceDocument67': 'CourtListener — Document 67 and State Department confirmations',
  'updatePage.disclaimerTitle': 'Legal context',
  'updatePage.sources': 'Sources',
  'updatePage.sourceCourt': 'CourtListener — September 9 order denying release',
  'updatePage.sourceReuters': 'Reuters — August 27 extradition and deadline report',
  'updatePage.sourceDocket': 'CourtListener — complete United States v. Tate docket',

  // Ways to Help
  'home.help.title': 'Ways to Help from Home',
  'home.help.card1Title': 'Sign the Online Petition Today!',
  'home.help.card1DescBefore': 'Click the picture above to be redirected to Change.org to sign the ',
  'home.help.card1Link': 'petition',
  'home.help.card1DescAfter': '. Make sure to use your real name and email address to be taken seriously.',
  'home.help.card2Title': 'Promote our Page',
  'home.help.card2Desc': 'Use social media and other platforms to promote our page to raise awareness and strengthen the cause.',
  'home.help.card3Title': 'Send us a Testimonial',
  'home.help.card3DescBefore': 'Write a testimonial and send it to us. How have these brothers helped you? Why do you believe they are innocent? Email us at ',
  'home.help.card3DescAfter': ' and we may publish your testimonial on our website.',

  // Help Power the Movement
  'home.power.title': 'HELP POWER THE MOVEMENT',
  'home.power.description': 'Tate Protest relies on supporters to fund peaceful event coordination, public-information research, outreach materials, website operations, and the technology required to keep the public informed.',
  'home.power.priority': 'CURRENT PRIORITY',
  'home.power.priorityTitle': 'AUGUST 27 PEACEFUL DEMONSTRATION',
  'home.power.priorityDesc': 'Help Tate Protest maintain public-information research, communications, outreach, and updates while the next court date remains unannounced.',
  'home.power.donate25': 'DONATE $25',
  'home.power.donate50': 'DONATE $50',
  'home.power.donate100': 'DONATE $100',
  'home.power.chooseAmount': 'CHOOSE AN AMOUNT',
  'home.power.learnMore': 'Learn how contributions are used',
  'home.power.disclaimer': 'Tate Protest is an independent advocacy and public-information platform. Contributions support Tate Protest operations and are not payments to Andrew Tate, Tristan Tate, or their legal teams.',

  // Support / Donation
  'home.support.kicker': 'Support',
  'home.support.title': 'Support the Work',
  'home.support.description': 'Help Tate Protest maintain its public-information platform, research case developments, produce educational content, and coordinate lawful peaceful advocacy.',
  'home.support.cta': 'Support Tate Protest',
  'home.support.howUsed': 'How Contributions Are Used',
  'home.support.infoTitle': 'Contribution Information',
  'home.support.item1': 'Contributions are processed securely and are not described as charitable donations or tax-deductible unless that status has been legally verified.',
  'home.support.item2': 'Contributions may be used for platform maintenance, research, educational content production, and lawful advocacy coordination.',
  'home.support.item3': 'Payment processing is handled through secure third-party providers. Refund requests can be directed to our contact channels.',
  'home.support.item4Before': 'For questions about contributions, contact us through the ',
  'home.support.item4After': '.',
  'home.support.contactPage': 'Contact page',

  // Footer
  'footer.tagline': 'Truth. Evidence. Freedom.',
  'footer.explore': 'Explore',
  'footer.romaniaCase': 'Romania Case',
  'footer.ukCase': 'UK Case',
  'footer.usProceedings': 'United States Proceedings',
  'footer.legalTimeline': 'Legal Timeline',
  'footer.about': 'About',
  'footer.aboutTateProtest': 'About Tate Protest',
  'footer.wilPujols': 'Wil Pujols',
  'footer.contact': 'Contact',
  'footer.mediaInquiries': 'Media Inquiries',
  'footer.submitTestimonial': 'Submit a Testimonial',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.terms': 'Terms and Conditions',
  'footer.privacy': 'Privacy Policy',
  'footer.contributionPolicy': 'Contribution Policy',
  'footer.sourceCorrections': 'Source & Corrections',
  'footer.protestUpdates': 'Protest Updates',
  'footer.caseCredits': 'Case Credits',
  'footer.supportTitle': 'Help sustain peaceful advocacy',
  'footer.supportBody': 'Your contribution helps support lawful event coordination, research, and communication.',
  'footer.supportButton': 'Support Tate Protest',
  'footer.disclaimer': 'TateProtest.com is an independent advocacy and public-information platform. It is not a law firm and does not provide legal advice. Unless expressly stated, it is not affiliated with Andrew Tate, Tristan Tate, or their legal representatives.',
  'footer.copyright': 'Copyright © 2026 Tate Protest — All Rights Reserved.',

  // Latest article banner
  'banner.latestArticle': 'Tate Protest Founder Wil Pujols, AKA “Neo,” Named on Witness List — Read the full article.',
  'banner.xSuspended': 'All Matrix attacks defeated. All systems are back online.',

  // Cookie Banner
  'cookie.title': 'Cookie Preferences',
  'cookie.description': 'We use essential cookies to ensure the website functions properly. Non-essential analytics and advertising cookies are only loaded with your consent.',
  'cookie.accept': 'Accept',
  'cookie.decline': 'Decline',
};